<template>
    
    <div class="filter">

        <slot @change="change"></slot>

    </div>

</template>

<script>
import Vue from 'vue';

export const FILTER_EVENT = 'filter'
export const RESET_FILTER_EVENT = 'resetfilters'

export const FilterBus = new Vue();

export function resetFilters() {
    FilterBus.$emit(RESET_FILTER_EVENT)
}

export default {
}

</script>

<style>

.filter {    
    display: flex;
    flex-direction: row;
    align-items: center;
}

.filter > button
.filter > label,
.filter > .button {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
}

.filter > input[type="text"] {
    width: 100%;
    max-width: 55rem;
}

.filter > label {
    margin-right: 0.5rem;
}

.filter > label:not(:first-child) {
    margin-left: 0.5rem;
}

.filter > .select {
    max-width: 55rem;  
}

.filter.filter--main {
    display: block;
    width: 100%;
    margin-right: 0;
}

.filter.filter--main > input {
    font-size: 140%;
    line-height: 160%;
}

.filter.filter--reset {
    margin-bottom: 0;
    justify-content: end;
}
</style>